import App from '../../components/App';
import props from '../../configs/propsLettercases';
import CaseConverterSection from '../../sections/static/CaseConverter';

export default function FontGenerator() {
  return (
    <App {...props}>
      <CaseConverterSection />
    </App>
  );
}
